import {DetailActions} from 'mc/lib/detail';
import {Api} from '../api';

const AREA = 'user';

export function fetchIfNeeded() {
    return DetailActions.fetchIfNeeded(AREA, true, Api.getUser);
}

export function invalidate() {
    return DetailActions.invalidate(AREA);
}

export function setSubjekt(subjekt) {
    return (dispatch, getState) => {
        const {app: {user: {data}}} = getState();
        dispatch(DetailActions.updateValue(AREA, {...data, subjekt}));
    };
}

export function deleteSubjekt() {
    return (dispatch, getState) => {
        const {app: {user: {data}}} = getState();
        dispatch(DetailActions.updateValue(AREA, {...data, subjekt: null}));
    };
}
